import { AxiosResponse } from 'axios'
import { APIDecoratorWithBaseURI } from './api'
import { SetStateAction } from 'react'

export interface LoginParams {
  token: string
  sso?: string
}

export interface LoginResponseData {
  success?: boolean
  error?: boolean
  message?: string
  errorCode?: string
  data?: {
    accessToken: string
  }
}

export const login = async (
  token: LoginParams
): Promise<SetStateAction<string | void>> => {
  const response = await APIDecoratorWithBaseURI(
    process.env.REACT_APP_API_AUTH
  ).post<String, AxiosResponse<LoginResponseData>>(
    `auth/dashboard/producer/login`,
    token,
    {
      responseType: 'json',
      headers: { 'content-type': 'application/json' },
      withCredentials: true,
    }
  )
  if (response.data.data !== undefined) {
    return response.data.data.accessToken
  }
}
